import { render, staticRenderFns } from "./WorkflowSmallList.vue?vue&type=template&id=483adcdc&scoped=true"
import script from "./WorkflowSmallList.vue?vue&type=script&lang=js"
export * from "./WorkflowSmallList.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSmallList.vue?vue&type=style&index=0&id=483adcdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483adcdc",
  null
  
)

export default component.exports